/**
 * This file contains some syntactic-sugar wrappers for making HeadlingLevelBoundary
 * easier to work with.
 */
import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import HeadingLevelBoundary from './HeadingLevelBoundary';
/**
 * Render a `section` tag and handle updating the heading level context
 */
var Section = forwardRef(function (props, ref) { return (React.createElement(HeadingLevelBoundary, __assign({ tag: "section" }, props, { ref: ref }))); });
Section.displayName = 'Section';
/**
 * Render a `main` tag and handle updating the heading level context
 */
var Main = forwardRef(function (props, ref) { return (React.createElement(HeadingLevelBoundary, __assign({ tag: "main" }, props, { ref: ref }))); });
Main.displayName = 'Main';
/**
 * Render a `nav` tag and handle updating the heading level context
 */
var Nav = forwardRef(function (props, ref) { return (React.createElement(HeadingLevelBoundary, __assign({ tag: "nav" }, props, { ref: ref }))); });
Nav.displayName = 'Nav';
export { Section, Main, Nav };
//# sourceMappingURL=tagWrappers.js.map